<template>
  <div class="sppt thumb-example" ref="content">
    <iframe
      :src="payurlI"
      id="pdfId"
      name="pdfNmae"
      width="100%"
      style="margin:0;padding:0"
      height="94%"
      frameborder="0"
    ></iframe>
    <div class="btnbox">
      <div class="flex:1"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['payurl'],
  components: {},
  data() {
    return {
      payurlI: '',
    };
  },
  methods: {},

  mounted() {
    this.payurlI =
      '/pdf/web/viewer.html?file=' + encodeURIComponent(this.payurl);
  },
};
</script>

<style lang="scss" scoped>
.sppt {
  background-color: gainsboro;
  height: 100%;
  width: 1200px;
}
.el-carousel__item {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.swiper {
  position: relative;
  &.gallery-top {
    height: 95%;
    width: 100%;
    .swiper-button-white {
      visibility: hidden;
    }
  }
  &.gallery-thumbs {
    height: 12%;
    box-sizing: border-box;
    padding: 10px 0;
    overflow: hidden;
    margin-top: -92px;
    width: 100%;
    padding-right: 600px;
    background-color: #5e5e5e7e;
  }
  &.gallery-thumbs .swiper-slide {
    width: 128px;
    height: 72px;
    opacity: 0.6;
  }
  &.gallery-thumbs .swiper-slide-active {
    background-color: white;
    opacity: 1;
  }
}
.swiper-slide {
  background-color: white;
  color: black;
}
.slide-img {
  height: 100%;
  width: 100%;
}
.slide-img.add {
  height: 120%;
  width: 120%;
}
.slide-img2 {
  height: 100%;
  width: 100%;
  position: relative;
}
.number {
  position: absolute;
  background-color: #717371;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  bottom: 0;
  right: 0;
  text-align: center;
  line-height: 20px;
  color: #bebec1;
}

.btnbox {
  height: 32px;
  background-color: #212228;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  padding: 0 10px;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;

  .btncenter,
  .btnright {
    display: flex;
    align-items: center;
    .ye {
      color: white;
      width: 36px;
      background: #3e3f49;
      border-radius: 10px;
      text-align: center;
      height: 23px;
      line-height: 23px;
      cursor: pointer;
    }
    .allye {
      color: white;
      text-align: center;
      padding-left: 5px;
      cursor: pointer;
    }
    i {
      color: white;
      font-size: 20px;
      padding: 0 10px;
      cursor: pointer;
    }
  }
}
.thumbsbox {
  background-color: #5e5e5e;
}

.swiper.gallery-thumbs .swiper-slide-active {
  border: 2px solid #1e97ff !important;
}
.swiper.gallery-thumbs {
  margin-top: -97px !important;
  height: 18% !important;
  padding-right: 0 !important;
}
</style>
